<template>
  <div class="container">
    <h1 class="title">Benutzerverwaltung</h1>
    <h2 class="subtitle">Benutzer verwalten</h2>
    <section>
      <div class="box">
        <b-table :data="users" paginated striped>
          <template slot-scope="props">
            <b-table-column field="userName" label="Benutzer">{{
              props.row.userName
            }}</b-table-column>
            <b-table-column field="email" label="Email"
              ><b-tag size="is-medium" class="is-italic"
                >{{ props.row.email }}
              </b-tag></b-table-column
            >
            <b-table-column field="userType" label="Art" centered>
              {{ props.row.userType }}
            </b-table-column>
            <b-table-column field="statistics" label="Statistik" centered>
              <b-field>
                <b-radio
                  v-model="props.row.statistics"
                  native-value="No"
                  @input="changeStatisticsSettings(props.row.userName, 0)"
                >
                  Nein
                </b-radio>

                <b-radio
                  v-model="props.row.statistics"
                  native-value="Yes"
                  @input="changeStatisticsSettings(props.row.userName, 1)"
                >
                  Ja
                </b-radio>

                <b-radio
                  v-model="props.row.statistics"
                  native-value="Only"
                  @input="changeStatisticsSettings(props.row.userName, 2)"
                >
                  Nur
                </b-radio>
              </b-field>
            </b-table-column>
            <b-table-column field="editor" label="Redaktion" centered>
              <b-field>
                <b-radio
                  v-model="props.row.editor"
                  native-value="No"
                  @input="changeEditorSettings(props.row.userName, 0)"
                >
                  Nein
                </b-radio>

                <b-radio
                  v-model="props.row.editor"
                  native-value="Yes"
                  @input="changeEditorSettings(props.row.userName, 1)"
                >
                  Ja
                </b-radio>

                <b-radio
                  v-model="props.row.editor"
                  native-value="Only"
                  @input="changeEditorSettings(props.row.userName, 2)"
                >
                  Nur
                </b-radio>
              </b-field>
            </b-table-column>
            <b-table-column centered>
              <b-button
                v-if="props.row.userType == 'BackOffice'"
                size="is-small"
                icon-left="plus"
                type="is-danger"
                @click="promoteToSupervisor(props.row)"
                >Supervisor Rechte geben</b-button
              >
              <b-button
                v-if="props.row.userType == 'BackOfficeSupervisor'"
                size="is-small"
                icon-left="trash"
                type="is-danger"
                @click="demoteFromSupervisor(props.row)"
                >Supervisor Rechte nehmen</b-button
              >
            </b-table-column>
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import userApi from '@/api/users-api'
export default {
  name: 'userManagment',
  data() {
    return {
      users: [],
    }
  },
  async mounted() {
    this.users = await userApi.list()
  },
  methods: {
    async promoteToSupervisor(user) {
      let result = await userApi.promoteToSupervisor(user.userName)
      if (result.success) {
        user.userType = 'BackOfficeSupervisor'
      }
    },
    async demoteFromSupervisor(user) {
      let result = await userApi.demoteToUser(user.userName)
      if (result.success) {
        user.userType = 'BackOffice'
      }
    },
    async changeStatisticsSettings(user, state) {
      let result = await userApi.changeStatisticsSettings(user, state)
      if (result.success) {
        this.$buefy.toast.open({
          message: 'Eintrag aktualisiert!',
          type: 'is-success',
        })
      }
    },
    async changeEditorSettings(user, state) {
      let result = await userApi.changeEditorSettings(user, state)
      if (result.success) {
        this.$buefy.toast.open({
          message: 'Eintrag aktualisiert!',
          type: 'is-success',
        })
      }
    },
  },
}
</script>
